import React, { Component, Fragment } from 'react';
import { debounce } from 'lodash';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import icons from '../../assets/comet/comet.svg';
import './styles.styl';

const deaMenuBreakpoint = 768;

class Layout extends Component {
  componentDidMount = () => {
    this.windowWidth = document.documentElement.clientWidth;
    window.addEventListener('resize', this.onWindowResize);

    if (this.windowWidth >= 1280) {
      // if browser window is at least 1280px wide, show the main menu by default
      this.props.setSidebarToggled(true);
    }
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.onWindowResize);
  }

  onWindowResize = debounce(() => {
    const newWindowWidth = document.documentElement.clientWidth;

    if (
      newWindowWidth < deaMenuBreakpoint &&
      this.windowWidth >= deaMenuBreakpoint
    ) {
      this.props.setSidebarToggled(false);
    }

    this.windowWidth = newWindowWidth;
  }, 200);

  toggleSidebar = () => {
    this.props.setSidebarToggled(!this.props.sidebarToggled);
  };

  render() {
    const isFrontPage = this.props.location.pathname === '/';

    return (
      <Fragment>
        {!isFrontPage && (
          <div className="layout__utility">
            <div className="layout__container">{this.props.utility}</div>
          </div>
        )}
        <div className="layout__container layout__container-main">
          {!isFrontPage && (
            <nav
              className={classNames('layout__sidebar', {
                'layout__sidebar--open': this.props.sidebarToggled
              })}
              aria-labelledby="sidebar-heading"
            >
              <h2 id="sidebar-heading" className="comet-screenreader-only">
                Main Menu
              </h2>

              <button
                aria-expanded={this.props.sidebarToggled}
                aria-controls="layout__sidebar__content"
                className="layout__sidebar__toggle"
                onClick={this.toggleSidebar}
              >
                <div className="layout__sidebar__toggle__arrow">
                  <svg
                    className="comet-icon--s"
                    aria-hidden="true"
                    focusable="false"
                  >
                    <use xlinkHref={`${icons}#caret-right`} />
                  </svg>
                </div>

                <span className="comet-screenreader-only">Main Menu</span>
              </button>

              <div
                id="layout__sidebar__content"
                className="layout__sidebar__content"
                hidden={!this.props.sidebarToggled}
              >
                {this.props.sidebar}
              </div>
            </nav>
          )}
          <main className="layout__main">{this.props.main}</main>
        </div>
        <div className="layout__container layout__container-footer">
          <footer className="layout__footer">{this.props.footer}</footer>
        </div>
      </Fragment>
    );
  }
}

// Props for types: ({ main, sidebar, utility, footer, location, sidebarToggled })
Layout.propTypes = {
  homeBackgroundImages: PropTypes.shape({
    backgroundHomeImage: PropTypes.string,
    mainHomeImage: PropTypes.string
  }),
  main: PropTypes.element,
  setSidebarToggled: PropTypes.func,
  sidebar: PropTypes.element,
  sidebarToggled: PropTypes.bool
};

export default Layout;



// WEBPACK FOOTER //
// ../core/src/components/Layout/Layout.js